<template>
  <section
    v-if="item"
    class="module dt-relative"
  >
    <h3>相关可播资源</h3>
    <ul :class="['dt-relative-wrap', item && item.length < 8 ? 'no-more' : '']">
      <li
        v-for="(i, index) in item"
        :key="index"
      >
        <a
          :href="i.url"
          :uigs="i._status ? type + '_out_' + i._status + '_' + index : type + '_out_list_video_' + index"
          :uigsparams="`play_type=video&play_url=${encodeURIComponent(i.ourl)}&play_site=${i.domain}`"
        >
          <div class="dt-relative-item-img">
            <Image-1 :src="i.picurl" />
            <span
              class="tag-play"
            ><i>{{ formatDuration(i.duration) }}</i></span>
            <span
              v-if="i._status === 'clips'"
              class="tag-type"
            >速看</span>
          </div>
          <div class="dt-relative-item-info">
            <p v-html="formatTitle(i.title)" />
          </div>
        </a>
      </li>
    </ul>
    <a
      v-if="item && item.length === 8"
      :href="moreurl"
      class="dt-more rgt"
      :uigs="type + '_out_list_video_more'"
    >
      <span>更多相关资源</span>
    </a>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import Image from './Image.vue';

export default {
  components: {
    'Image-1': Image,
  },
  computed: {
    ...mapState('detail', ['itemData']),
    item() {
      const { cache } = this.itemData;
      if (cache && cache.length > 0) {
        return cache;
      }
      return '';
    },
    type() {
      const data = this.itemData;
      let { type } = data;
      if (type === 'series') {
        if (data.dockey.startsWith('teleplay')) {
          type = 'teleplay';
        } else if (data.dockey.startsWith('cartoon')) {
          type = 'cartoon';
        }
      }
      return type;
    },
    moreurl() {
      return this.itemData.cache_moreurl;
    },
  },
  methods: {
    formatTitle(str) {
      if (str) {
        return str.toString().replace(/\^(&|@)\^/g, '');
      }
      return '';
    },
    formatDuration(duration) {
      if (duration === '' || typeof duration === 'undefined') {
        return '';
      }
      if (duration.toString().indexOf(':') > -1) {
        return duration;
      }
      let durationStr = '';
      const durationNum = parseInt(duration, 10);

      const hour = Math.floor(durationNum / 3600);
      const min = Math.floor((durationNum - hour * 3600) / 60);
      const sec = durationNum - hour * 3600 - min * 60;

      if (sec < 0 || hour < 0 || min < 0) {
        return durationStr;
      }

      if (!(min === 0 && sec === 0 && hour === 0)) {
        if (hour !== 0) {
          durationStr = `${hour}:`;
        }
        if (min === 0) {
          durationStr += '00:';
        } else {
          if (min < 10) durationStr += `0${min}:`;
          else durationStr += `${min}:`;
        }
        if (sec === 0) {
          durationStr += '00';
        } else if (sec > 0) {
          if (sec < 10) durationStr += `0${sec}`;
          else durationStr = durationStr + sec;
        }
      }
      return durationStr;
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_detail.scss';

.dt-relative-wrap {
  &.no-more {
    margin-bottom: 10px;
  }
}
</style>
